"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upperFirst = void 0;
exports.upperFirst = (value) => value[0].toUpperCase() + value.slice(1);
//# sourceMappingURL=upper-first.js.map